import { ethers } from 'ethers';
import { useEffect, useState } from 'react';
import './App.css';
import Mooncat from './components/Mooncat';
import { getCatSerials, getOwnedMooncats, getAllWrappedCats, getOwnedWrappedMooncats } from './lib';
import {
  Switch,
  Route,
} from "react-router-dom";
import { AppContext } from './libs/contextLib';
import MyCats from './components/MyCats';
import CatDetails from './components/CatDetails';
import Navbar from './components/Navbar';

function App() {

  const [myCats, setMyCats] = useState([])
  const [connectedAddress, setConnectedAddress] = useState(undefined)
  const [serials, setSerials] = useState({})
  const [allWrapped, setAllWrapped] = useState({})
  const [ownedWrapped, setOwnedWrapped] = useState([])
  const [ownedWrappedCatIds, setOwnedWrappedCatIds] = useState([])

  const getInjectedProvider = () => new ethers.providers.Web3Provider(window.web3.currentProvider)


  const getUserAddress = async (provider = getInjectedProvider()) => {
    const accounts = await window.ethereum.request({ method: 'eth_requestAccounts' });
    /*
    const accounts = await provider.listAccounts()
    return accounts[0]
    */
    return accounts[0]
  }

  function login() {
    console.log('login called')
    getUserAddress()
      .then(address => {
        setConnectedAddress(address)
      })
      .catch(error => {
        // notify('Connect to Web3 failed! Metamask installed, unlocked?')
        console.log('Login failed', error)
      })
  }

  useEffect(() => {
    const serials = getCatSerials()
    setSerials(serials)
    getAllWrappedCats().then(res => setAllWrapped(res))
    return () => {
    }
  }, [])

  useEffect(() => {

    if (!ownedWrapped || !allWrapped) {
      return
    }

    let tempInverted = {}
    let keys = Object.keys(allWrapped)
    for (const key of keys) {
      let value = allWrapped[key]
      tempInverted[value] = key
    }

    let ownedWrappedCatIds = []
    for (const owned of ownedWrapped) {
      let catId = tempInverted[owned]
      ownedWrappedCatIds.push(catId)
    }
    setOwnedWrappedCatIds(ownedWrappedCatIds)
    
    return () => {
    }
  }, [ownedWrapped, allWrapped])

  useEffect(() => {
    if (!connectedAddress) {
      return
    }
    getOwnedMooncats(connectedAddress)
      .then(catIds => {
        setMyCats(catIds)
      })
      .catch(err => console.log('error', err))

    getOwnedWrappedMooncats(connectedAddress)
      .then(res => setOwnedWrapped(res))
      .catch(err => console.log('error', err))

    return () => {
    }
  }, [connectedAddress])


  return (
    <div className="App" style={{ backgroundImage: 'url(https://mooncatrescue.com/img/bg0.png)', display: 'flex', flexDirection: 'column'  }}>

      <Navbar style={{ paddingLeft: '2rem', paddingRight: '2rem'}} />

      <AppContext.Provider value={{
        myCats,
        login,
        serials,
        allWrapped,
        ownedWrappedCatIds
      }}>
        <div style={{ 
          marginTop: '2rem', 
          color: 'white', fontWeight: 600, 
          overflowY: 'auto',
          backgroundImage: 'url(https://mooncatrescue.com/img/bg2.png)',
          paddingLeft: '2rem', paddingRight: '2rem' }}>
          <Switch>
            <Route path="/cat/:catId">
              <CatDetails />
            </Route>
            <Route path="/">
              <MyCats />
            </Route>
          </Switch>
        </div>
      </AppContext.Provider>
    </div>
  );
}

export default App;
